import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi, useAuth } from '../../../hooks';
import { UserBlockAction } from '../../../components/UserDashboard/overview/types';

type Payload = {
  userBlockId: string;
  action: UserBlockAction
  userId: string;
};

export const useUserBlockAction = () => {
  const queryClient = useQueryClient();
  const { api } = useApi({ throwIfError: true });
  const { userToken } = useAuth();

  const mutation = useMutation({
    mutationFn: async ({ userBlockId, action, userId }: Payload) => {
      return await api({
        route: `/private/dashboard/user/${userId}/blocks/${userBlockId}/${action}/`,
        method: 'POST',
        token: userToken,
      });
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['user-blocks'],
      });
    },
  });

  return { mutation };
};
